import { createActionGroup, emptyProps } from '@ngrx/store';

export const CheckoutHeaderComponentActions = createActionGroup({
  source: 'Checkout Header Component',
  events: {
    'Sign In Clicked': emptyProps(),
  },
});
